import React, { useState } from "react";
import { Box, TextField, Button, Grid } from "@mui/material";

import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import SaveIcon from "@mui/icons-material/Save";
import { addProduct } from "../../services/source";

const Upload = ({ refreshProducts }) => {
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState("");
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [price, setPrice] = useState("");
  const [stock, setStock] = useState("");
  const [location, setLocation] = useState("");

  const handleImage = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    setImage(file);
    setPreview(URL.createObjectURL(file));
  };

  const handleSave = async () => {
    if (!image) {
      alert("Please select an image.");
      return;
    }

    const formData = new FormData();

    formData.append("image", image);
    formData.append("title", title);
    formData.append("subtitle", subtitle);
    formData.append("alt", title);
    formData.append("height", 200);
    formData.append("price", price);
    formData.append("stock", stock);

    formData.append("location", location);

    const res = await addProduct(formData);

    if (res.data.success) {
      // Reload products on Dashboard
      await refreshProducts();

      // Clear form
      setImage(null);
      setPreview("");
      setTitle("");
      setSubtitle("");
      setPrice("");
      setStock("");
      setLocation("");

      alert("Product uploaded successfully.");
    } else {
      alert(res.data.message);
    }

    // try {
    //   await addProduct(formData).then((res) => console.log(res));

    //   setImage(null);
    //   setPreview("");
    //   setTitle("");
    //   setSubtitle("");
    //   setPrice("");
    //   setStock("");
    //   setLocation("");
    // } catch (error) {
    //   console.log(error);
    //   alert("Upload failed.");
    // }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        py: 4,
        px: 2,
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Button
            fullWidth
            component="label"
            variant="outlined"
            startIcon={<CloudUploadIcon />}
          >
            Select Image
            <input hidden type="file" accept="image/*" onChange={handleImage} />
          </Button>
        </Grid>

        {preview && (
          <Grid item xs={12}>
            <Box
              component="img"
              src={preview}
              sx={{
                width: "100%",
                maxHeight: 350,
                objectFit: "cover",
                borderRadius: 2,
              }}
            />
          </Grid>
        )}

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Subtitle"
            value={subtitle}
            onChange={(e) => setSubtitle(e.target.value)}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Price"
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            label="Stock"
            type="number"
            value={stock}
            onChange={(e) => setStock(e.target.value)}
          />
        </Grid>

        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Location"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
          />
        </Grid>

        <Grid item xs={12}>
          <Button
            fullWidth
            variant="contained"
            size="large"
            startIcon={<SaveIcon />}
            onClick={handleSave}
          >
            Save Product
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Upload;
